import { oc } from 'ts-optchain';
import _ from 'lodash';

import { StoreType } from '@tock/shared/utils/connect';
import { createDeepEqualSelector } from 'utils/service/selectorUtils';
import { createSelector } from 'reselect';

let existing: Dictionary<number[]> | undefined = {};
export const partyToTableSelector = createDeepEqualSelector(
  (state: StoreType) => oc(state).service.app.app.partyIdToTableId(),
  (partyIdToTableId) => {
    if (partyIdToTableId && existing) {
      _.forEach(partyIdToTableId, (entry, key) => {
        if (existing && existing[key] && _.isEqual(entry, existing[key])) {
          partyIdToTableId[key] = existing[key];
        }
      });
    }
    existing = partyIdToTableId;
    return partyIdToTableId || {};
  }
);

export const tableToPartySelector = createSelector(partyToTableSelector, (partyIdToTableId) => {
  const tables: Dictionary<number[]> = {};
  _.forEach(partyIdToTableId, (tableIds, partyIdString: string) => {
    const partyId = parseInt(partyIdString, 10);
    _.forEach(tableIds, (tableId) => {
      if (tables[tableId]) {
        tables[tableId].push(partyId);
      } else {
        tables[tableId] = [partyId];
      }
    });
  });
  return tables || {};
});
